import { segment } from '@actions/analytics';
import {
  ADD_PARENT_CONTACT_CLICKED,
  EDIT_PARENT_CONTACT_CLICKED,
  PARENT_CONTACT_ADDED,
  PARENT_CONTACT_UPDATED,
  PARENT_OTP_REQUESTED,
  PARENT_OTP_SUBMITTED,
  PARENT_OTP_INVALID
} from '@cont/Settings/constants/segment';
import type { ParentContactAnalyticsSource } from './types';

export { PARENT_CONTACT_ANALYTICS_SOURCES } from './types';
export type { ParentContactAnalyticsSource } from './types';

type ParentContactAnalyticsProps = {
  source: ParentContactAnalyticsSource;
  userHasSubscription: boolean;
};

const buildParentContactProps = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => ({
  source,
  user_has_subscription: userHasSubscription
});

export const trackAddParentContactClicked = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    ADD_PARENT_CONTACT_CLICKED,
    buildParentContactProps({ source, userHasSubscription })
  );
};

export const trackParentOtpRequested = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    PARENT_OTP_REQUESTED,
    buildParentContactProps({ source, userHasSubscription })
  );
};

export const trackParentOtpSubmitted = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    PARENT_OTP_SUBMITTED,
    buildParentContactProps({ source, userHasSubscription })
  );
};

export const trackParentOtpInvalid = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    PARENT_OTP_INVALID,
    buildParentContactProps({ source, userHasSubscription })
  );
};

export const trackParentContactAdded = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    PARENT_CONTACT_ADDED,
    buildParentContactProps({ source, userHasSubscription })
  );
};

export const trackEditParentContactClicked = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    EDIT_PARENT_CONTACT_CLICKED,
    buildParentContactProps({ source, userHasSubscription })
  );
};

export const trackParentContactUpdated = ({
  source,
  userHasSubscription
}: ParentContactAnalyticsProps) => {
  segment.track(
    PARENT_CONTACT_UPDATED,
    buildParentContactProps({ source, userHasSubscription })
  );
};
